import { render, staticRenderFns } from "./forward.vue?vue&type=template&id=a3bb7fb6&"
import script from "./forward.vue?vue&type=script&lang=ts&"
export * from "./forward.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports